import { render, staticRenderFns } from "./cardCantent.vue?vue&type=template&id=6bfcbd42&scoped=true&"
import script from "./cardCantent.vue?vue&type=script&lang=js&"
export * from "./cardCantent.vue?vue&type=script&lang=js&"
import style0 from "./cardCantent.vue?vue&type=style&index=0&id=6bfcbd42&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bfcbd42",
  null
  
)

export default component.exports